import { getEnabledSwitchActions, getSetApplicationScopeAction } from '@/utils/common/tableActions'
import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('report.run_now'),
        action: (obj) => {
          this.onManager('performAction', {
            id: obj.id,
            managerArgs: {
              action: 'send-report',
            },
          }).then(() => {
            this.$message.success(i18n.t('message.exec_success'))
          }).catch(() => {
            this.$message.error(i18n.t('message.exec_fail'))
          })
        },
        meta: (obj) => ({
          validate: obj.enabled,
          tooltip: !obj.enabled ? i18n.t('report.runnow.disable.tooltip') : '',
        }),
      },
      {
        label: i18n.t('system.text_153'),
        actions: obj => {
          return [
            {
              label: i18n.t('common.edit'),
              action: () => {
                if (!obj.id.startsWith('default_')) {
                  this.$router.push({
                    name: this.wholeType === 'month' ? 'MonthReportEdit' : 'DailyReportEdit',
                    params: {
                      reportData: obj,
                    },
                  })
                } else {
                  this.$router.push({
                    name: this.wholeType === 'month' ? 'MonthReportCreate' : 'DailyReportCreate',
                    params: obj,
                  })
                }
              },
            },
            {
              label: i18n.t('report.modify_notify_role'),
              action: () => {
                this.createDialog('ReportChangeNotifyRoleDialog', {
                  name: this.$t(`report.${this.wholeType}_report`),
                  wholeType: this.wholeType,
                  data: [obj],
                  onManager: this.onManager,
                  columns: this.columns,
                })
              },
            },
            ...getEnabledSwitchActions(this, obj, [`${this.wholeType}_reports_perform_enable`, `${this.wholeType}_reports_perform_disable`], {
              metas: [
                () => {
                  const ret = {
                    validate: !obj.enabled,
                  }
                  return ret
                },
                () => {
                  const ret = {
                    validate: obj.enabled,
                  }
                  return ret
                },
              ],
              resourceName: this.$t(`report.${this.wholeType}_report_subscription`),
            }),
            getSetApplicationScopeAction(this, {
              name: this.$t(`report.${this.wholeType}_report`),
              scope: 'domain',
              resource: `${this.wholeType}_reports`,
            }, {
              permission: `${this.wholeType}_reports_perform_public`,
            }),
            {
              label: i18n.t('common.action.delete'),
              action: () => {
                this.createDialog('DeleteResDialog', {
                  name: this.$t(`report.${this.wholeType}_report_subscription`),
                  title: i18n.t('common.action.delete'),
                  vm: this,
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                const ret = { validate: !!(obj.css || obj.templates) }
                if (!ret.validate) {
                  ret.tooltip = i18n.t('report.cannot_delete_default_report')
                }
                return ret
              },
            },
          ]
        },
      },
    ]
  },
  methods: {
  },
}
